export function lockBodyScroll(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const isStandalone =
    (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    // @ts-ignore - iOS Safari standalone flag
    (typeof navigator !== 'undefined' && (navigator as any).standalone);
  if (isStandalone) return;

  const w = window as any;
  w.__oreogScrollLockCount = (w.__oreogScrollLockCount || 0) + 1;
  document.body.style.overflow = 'hidden';
}

export function unlockBodyScroll(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const w = window as any;
  if (!w.__oreogScrollLockCount) {
    document.body.style.overflow = '';
    return;
  }
  w.__oreogScrollLockCount = Math.max(0, (w.__oreogScrollLockCount as number) - 1);
  if (w.__oreogScrollLockCount === 0) {
    document.body.style.overflow = '';
  }
}
